import methods from '@/enums/methods';
import ThothV2 from '../base/thothV2';

class GatewayExpenseService extends ThothV2 {

    saveExpense({ date }) {
        return this.fetch({
            url: 'gateway-expense/save',
            method: methods.POST,
            data: { date },
        });
    }

    getHistoric() {
        return this.fetch({
            url: 'gateway-expense/historic',
            method: methods.GET,
        });
    }

    getMetrics() {
        return this.fetch({
            url: 'gateway-expense/metrics',
            method: methods.GET,
        });
    }

    /**
     * @param {Object} payload
     * @param {string} payload.gateway 
     * @param {Object} payload.metrics 
     */
    updateMetrics({ gateway, metrics }) {
        return this.fetch({
            url: 'gateway-expense/metrics/update',
            method: methods.PUT,
            data: {
                gateway,
                metrics,
            },
        });
    }
}

export default new GatewayExpenseService();